<template>
  <div class="uploader-component">
    <label class='file-uploader' :style="style">
      Escolher imagem
      <input type='file' @input="handleImage" ref="input" />
    </label>

    <div class='error-content' v-if="error">
      <p :style="{ color: $themes.danger }">{{ errorMessage[0] }}</p>
    </div>

    <div class="file-preview" v-if="image">
      <div class="image-container">
        <p>{{ imageName }}</p>
        <img :src="image" />
      </div>
      <div class="action-container">
        <p @click="handleRemove">Remover</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  data () {
    return {
      source: '',
      imageName: '',
    }
  },
  computed: {
    style () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    image () {
      return this.value
    },
  },
  props: {
    value: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleImage (e) {
      this.handlePreview(e.target.files)
    },
    handlePreview (files) {
      if (Array.from(files).length) {
        const reader = new FileReader()

        reader.onload = (e) => {
          // this.source = e.target.result
          this.imageName = files[0].name
          this.$emit('input', e.target.result)
        }

        reader.readAsDataURL(files[0])
      }
    },
    handleRemove () {
      this.$emit('input', '')
      this.$refs.input.value = ''
      this.source = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.uploader-component {
  margin: 10px 0;
  flex: 1;
  padding: 0.75rem;
}

.error-content p {
  font-size: 0.8rem;
  padding: 0.75rem;
}

.file-uploader {
  position: relative;
  padding: 0.75rem;
  border-radius: 1.5rem;
  color: #ffffff;
  cursor: pointer;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 1;
    height: 1;
    opacity: 0;
    z-index: -1;
  }
}

.file-preview {
  background-color: rgb(245, 248, 249);
  margin-top: 30px;
  padding: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    width: 60px;
    height: 60px;
    object-fit: contain;
    border: 1px solid #dddddd;
  }

  .action-container {
    p {
      color: red;
      text-transform: uppercase;
      cursor: pointer;
    }
  }
}
</style>
